import moment from "moment"
export function capitalize(text) {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : ''
}

export function upperCase(text) {
    return text ? text.toUpperCase() : ''
}

export function formatCurrency(value, currency = 'MXN', decimals = 2) {
    const num = Number(value)
    if (isNaN(num)) return '—'
    const formatted = num.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: decimals, minimumFractionDigits: decimals })
    return `$ ${formatted} ${currency}`
}

export function renderDate(date,format = 'L') {
  if (typeof date === "number" && date.toString().length === 10) {
    return moment.unix(date).format(format);
  }
  return moment(date).format(format);

}

export function canAccess(list) {//Importar a Vuex
  if (!list || list === '' || (Array.isArray(list) && list.length === 0)) {
    return true
  }
  const permissions = JSON.parse(localStorage.getItem('permissions')) || []
  const requiredPermissions = Array.isArray(list) ? list : [list]

  return requiredPermissions.some(permission =>
    permissions.includes(permission)
  )
}







